/// <amd-module name="Test/TestPlansHubRefresh/TestHub/Utils/TestHubRefreshFilterCommon" />
import { ITestHubListBoxItemData } from "Test/TestPlansHubRefresh/TestPlansHubRefreshFilter/TestPlansHubRefreshFilterComponent.Types";
import { ObservableArray } from "VSS/Core/Observable";
import { IVssPageContext } from "VSS/Platform/Context";
import { IPageData, IVssPageService } from "VSS/Platform/Page";
import { ListSelection } from "VSSUI/List";
import { IListBoxItem } from "VSSUI/ListBox";
import { DropdownMultiSelection } from "VSSUI/Utilities/DropdownSelection";

/**
 * TestHubRefreshFilterCommon: This namespace houses the filter values and the selection objects.
 * This is required to persist their values and selections across tab switches between Define and Execute.
 * Both the Define and Execute tab make use of these objects to store the filter values, sort of globally, this makes the filter value persistence seemless.
 */
export namespace TestHubRefreshFilterCommon {
    export const assignedToFilterValues = new ObservableArray<IListBoxItem<ITestHubListBoxItemData>>();
    export const stateFilterValues = new ObservableArray<IListBoxItem<ITestHubListBoxItemData>>();
    export const outcomeFilterValues = new ObservableArray<IListBoxItem<ITestHubListBoxItemData>>();
    export const testerFilterValues = new ObservableArray<IListBoxItem<ITestHubListBoxItemData>>();
    export const configurationFilterValues = new ObservableArray<IListBoxItem<ITestHubListBoxItemData>>();

    export const assignedToFilterSelection = new DropdownMultiSelection();
    export const stateFilterSelection = new DropdownMultiSelection();
    export const outcomeFilterSelection = new ListSelection(false);
    export const testerFilterSelection = new DropdownMultiSelection();
    export const configurationFilterSelection = new DropdownMultiSelection();

    /**
     * defaultAtMeTesterData is the data object associated with the default '@me' tester
     */
    export let defaultAtMeTesterData: ITestHubListBoxItemData;

    /**
     * Returns the 'data' object associated with the '@me' filter value. This data object is used to set '@me' selection in filter bar by default in PointsSaga.
     */
    export function getDefaultAtMeTesterData(pageContext: IVssPageContext): ITestHubListBoxItemData {
        if (!TestHubRefreshFilterCommon.defaultAtMeTesterData) {
            const pageService = pageContext.getService<IVssPageService>("IVssPageService");
            const pageData: IPageData | undefined = pageService.getData();

            // '@me' is really the currently logged-in user
            if (pageData && pageData.user && pageData.user.id) {
                defaultAtMeTesterData = {
                    key: pageData.user.displayName,
                    value: {
                        displayName: pageData.user.displayName,
                        id: pageData.user.id
                    }
                };
            }
        }

        return defaultAtMeTesterData;
    }
}
